import { render, staticRenderFns } from "./HornorBuyGuideOpen.vue?vue&type=template&id=3c151679&scoped=true&"
import script from "./HornorBuyGuideOpen.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGuideOpen.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGuideOpen.vue?vue&type=style&index=0&id=3c151679&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c151679",
  null
  
)

export default component.exports